/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-07-01 11:27:11
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbGoodsClass {
    /**
     * 获取分类
     */
    export var GetAllGoodsClassList = (body: any): Promise<any> => {
        return Get(`/api/TbGoodsClass/GetAllGoodsClassList`, body);
    };
    /**
     * 新增商品分类
     */
    export var PostTbGoodsClass = (body: any): Promise<any> => {
        return Post(`/api/TbGoodsClass/PostTbGoodsClass`, body);
    };
    /**
     * 删除商品分类
     */
    export var DeleteTbGoodsClass = (id:any): Promise<any> => {
        return Delete(`/api/TbGoodsClass/DeleteTbGoodsClass?id=${id}`, {});
    };
    /**
     * 修改商品分类
     */
    export var PutTbGoodsClass = (body: any): Promise<any> => {
        return Put(`/api/TbGoodsClass/PutTbGoodsClass`, body);
    };
    /**
     * 商品一级分类排序
     */
    export var TbGoodsClassSort = (body: any): Promise<any> => {
        return Put(`/api/TbGoodsClass/TbGoodsClassSort`, body);
    };
    /**
     * 查询商品分类列表
     */
    export var GetTbGoodsClassByIsParent = (body: any): Promise<any> => {
        return Get(`/api/TbGoodsClass/GetTbGoodsClassByIsParent`, body);
    };
    
   
  
    
}



// WEBPACK FOOTER //
// ./src/http/api_TbGoodsClass.ts